import PatchController from '../PatchController';

export default class DashboardController extends PatchController {
	public handle() {
		this.redirect(this.routes.dashboard.indexRoute.href);
	}
}
